/** The journey: 8 parts, 42 modules. Open modules are buttons; the rest show as coming soon. */
import { PARTS, MODULES, LOGO, TOTAL_HOURS } from "./courseMap";

export default function CourseMap({ isDark, onStart }) {
  const ink = isDark ? "#f0f7f0" : "#0d1a0f";
  const sub = isDark ? "#9fb7a2" : "#4b6a50";
  const card = isDark ? "#13231a" : "#ffffff";
  const line = isDark ? "#223328" : "#d8edd8";
  const open = MODULES.filter((m) => m.live).length;
  return (
    <section aria-label="Course map" style={{ marginBottom: 36 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 6 }}>
        <img src={LOGO} alt="Imfuyo MbuziPlus" style={{ width: 52, height: 52, objectFit: "contain", borderRadius: 10, background: "#fff", border: `1px solid ${line}` }} />
        <div>
          <h2 style={{ margin: 0, fontSize: 26, fontWeight: 800, letterSpacing: "-0.02em", color: ink }}>All 8 parts, {MODULES.length} modules</h2>
          <div style={{ fontSize: 15, color: sub }}>{TOTAL_HOURS} study hours in total</div>
        </div>
      </div>
      <p style={{ margin: "8px 0 20px", fontSize: 16, color: sub, lineHeight: 1.55 }}>All {open} modules are open. Tap any module to start. We suggest working through the parts in order, the way a farm grows.</p>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {PARTS.map((p) => {
          const mods = MODULES.filter((m) => m.part === p.no);
          const hrs = mods.reduce((n, m) => n + m.hours, 0);
          return (
            <div key={p.no} style={{ background: card, border: `1px solid ${line}`, borderRadius: 16, overflow: "hidden" }}>
              <div style={{ background: "linear-gradient(90deg,#285020,#3E7A32)", color: "#fff", padding: "10px 16px", display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap" }}>
                <span style={{ fontWeight: 800, fontSize: 17 }}>Part {p.no}: {p.name}</span>
                <span style={{ fontSize: 14.5, opacity: 0.95 }}>{mods.length} modules · {hrs} hours</span>
              </div>
              <div style={{ padding: "8px 16px 4px", fontSize: 15, color: sub }}>{p.about}</div>
              <ul style={{ listStyle: "none", margin: 0, padding: "4px 8px 10px" }}>
                {mods.map((m) => (
                  <li key={m.no}>
                    <button
                      onClick={() => m.live && onStart(m.id)}
                      disabled={!m.live}
                      style={{ width: "100%", textAlign: "left", display: "flex", alignItems: "center", gap: 12, padding: "12px 10px", borderRadius: 10, border: "none", background: "transparent", color: ink, cursor: m.live ? "pointer" : "default", opacity: m.live ? 1 : 0.62, fontFamily: "inherit", fontSize: 16 }}
                    >
                      <span style={{ width: 30, height: 30, borderRadius: "50%", background: m.live ? "#3E7A32" : isDark ? "#223328" : "#e6efe2", color: m.live ? "#fff" : sub, display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 12.5, flexShrink: 0 }}>{m.no}</span>
                      <span style={{ flex: 1, minWidth: 0 }}>{m.title}</span>
                      <span style={{ fontSize: 14, color: sub, whiteSpace: "nowrap" }}>{m.hours} h</span>
                      <span style={{ fontSize: 14, fontWeight: 800, color: m.live ? "#3E7A32" : sub, whiteSpace: "nowrap", minWidth: 74, textAlign: "right" }}>{m.live ? "Open" : "Opens soon"}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </section>
  );
}
